/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because RCF depends on rotor radius, RPM alone isn't reproducible across machines. Protocols specify RCF so the same force is applied on any rotor.`)
};

const es_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como la RCF depende del radio del rotor, las RPM por sí solas no son reproducibles entre equipos. Los protocolos especifican la RCF para aplicar la misma fuerza en cualquier rotor.`)
};

const de_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da die RCF vom Rotorradius abhängt, ist die Drehzahl allein nicht geräteübergreifend reproduzierbar. Protokolle geben die RCF an, damit auf jedem Rotor dieselbe Kraft wirkt.`)
};

const nl_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat RCF afhankelijk is van de rotorstraal, is RPM alleen niet reproduceerbaar tussen apparaten. Protocollen specificeren RCF zodat dezelfde kracht op elke rotor wordt toegepast.`)
};

const fr_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comme la RCF dépend du rayon du rotor, les RPM seuls ne sont pas reproductibles d'un appareil à l'autre. Les protocoles précisent la RCF afin que la même force soit appliquée quel que soit le rotor.`)
};

const it_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poiché l'RCF dipende dal raggio del rotore, gli RPM da soli non sono riproducibili tra macchine diverse. I protocolli specificano l'RCF così da applicare la stessa forza su qualsiasi rotore.`)
};

const pt_br2_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a RCF depende do raio do rotor, a RPM sozinha não é reprodutível entre máquinas. Os protocolos especificam a RCF para que a mesma força seja aplicada em qualquer rotor.`)
};

const pt_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a RCF depende do raio do rotor, a RPM por si só não é reprodutível entre máquinas. Os protocolos especificam a RCF para que a mesma força seja aplicada em qualquer rotor.`)
};

const ja_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCFはローター半径に依存するため、RPMだけでは装置間で再現性がありません。プロトコルでRCFを指定することで、どのローターでも同じ力を適用できます。`)
};

const zh_gf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为 RCF 取决于转子半径，仅凭 RPM 在不同机器间无法重现结果。方案中规定 RCF，才能确保在任何转子上施加相同的力。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_a2", locale)
	if (locale === "en") return en_gf_faq_a2(inputs)
	if (locale === "es") return es_gf_faq_a2(inputs)
	if (locale === "de") return de_gf_faq_a2(inputs)
	if (locale === "nl") return nl_gf_faq_a2(inputs)
	if (locale === "fr") return fr_gf_faq_a2(inputs)
	if (locale === "it") return it_gf_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_a2(inputs)
	if (locale === "pt") return pt_gf_faq_a2(inputs)
	if (locale === "ja") return ja_gf_faq_a2(inputs)
	return zh_gf_faq_a2(inputs)
};